import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ToastProvider } from './components/Toast';
import { queryClient } from './services/queryClient';
import { initializeMarker } from './utils/marker';
import './styles/globals.css';
import 'react-quill/dist/quill.snow.css';

// Initialize marker.io for staging environment only
initializeMarker();

console.log('🎨 Ministry of Wine Admin - Starting...');

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
